/* SkyClean Drones – Kostenrechner.

   Die Rechnung ist unverändert gegenüber der bisherigen Fassung:

     Preis je m²  = Grundpreis(Leistung, Verschmutzung) × Höhenfaktor(Höhe)
     Flächenkosten = Summe über alle angegebenen Flächen
     − Staffelrabatt ab der eingestellten Gesamtfläche
     + Zuschlag, wenn kein Wasseranschluss vorhanden ist
     + Anfahrt: Satz je km × Entfernung × 2 (Hin- und Rückweg)
     = Zwischensumme; liegt sie unter dem Mindestauftrag, wird auf ihn angehoben
     + Mehrwertsteuer für den Bruttopreis

   Alle Zahlen kommen aus dem Theme-Editor und stehen als JSON im Markup.
   Neu gegenüber der alten Fassung: Karte und Entfernungsdienste laufen erst
   nach ausdrücklichem Klick – vorher geht keine Anfrage nach draußen. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var cfgEl = root.querySelector('[data-calc-config]');
    if (!cfgEl) return;
    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var unlocked = false;
    var reviewing = false;
    var mapReady = false;
    var map = null;
    var destMarker = null;

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return root.querySelectorAll(s); };

    /* -------------------------------------------------------- Hilfsmittel */
    function num(el) {
      if (!el) return 0;
      var v = Number(String(el.value || '0').replace(',', '.'));
      return (!isFinite(v) || v < 0) ? 0 : v;
    }
    function euro(v) {
      try { return (isFinite(v) ? v : 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
      catch (e) { return (Math.round(v * 100) / 100) + ' €'; }
    }
    function svc(key) {
      for (var i = 0; i < CFG.services.length; i++) if (CFG.services[i].key === key) return CFG.services[i];
      return CFG.services[0];
    }
    function soilPrice(s, soil) {
      return soil === 'light' ? s.light : (soil === 'mid' ? s.mid : s.heavy);
    }
    function soilLabel(v) { return v === 'light' ? 'Gering' : (v === 'mid' ? 'Mittel' : 'Stark'); }
    function heightFactor(h) {
      for (var i = 0; i < CFG.heights.length; i++) if (h <= CFG.heights[i].upTo) return CFG.heights[i].factor;
      return CFG.heights.length ? CFG.heights[CFG.heights.length - 1].factor : 1;
    }
    function tier(area) {
      for (var i = 0; i < CFG.tiers.length; i++) if (area >= CFG.tiers[i].from) return CFG.tiers[i];
      return null;
    }
    function radio(name, fallback) {
      var els = qa('input[name="' + name + '"]');
      for (var i = 0; i < els.length; i++) if (els[i].checked) return els[i].value;
      return fallback;
    }

    /* --------------------------------------------------------- Bereich rechnen */
    function part(n) {
      var area = Math.min(Math.max(num(q('#scdk-a' + n)), 0), 50000);
      var height = Math.min(Math.max(num(q('#scdk-h' + n)), 0), 120);
      var key = radio('scdk_service_' + n, CFG.services[0].key);
      var soil = radio('scdk_soil_' + n, 'light');
      if (area <= 0) return { on: false, area: 0, height: 0, key: key, soil: soil, perM2: 0, cost: 0 };
      if (height <= 0) height = 12;
      var perM2 = soilPrice(svc(key), soil) * heightFactor(height);
      return { on: true, area: area, height: height, key: key, soil: soil, perM2: perM2, cost: perM2 * area };
    }

    /* Alle eingeblendeten Flächen, in der Reihenfolge, in der sie stehen.
       Ausgeblendete zählen nicht mit – auch nicht, wenn noch Werte drinstehen. */
    function activeParts() {
      var out = [];
      var max = CFG.maxParts || 2;
      for (var i = 1; i <= max; i++) {
        var box = q('#scdk-pos' + i);
        if (!box || box.hidden) continue;
        var p = part(i);
        p.index = i;
        out.push(p);
      }
      return out;
    }

    function address() {
      var z = q('#scdk-zip') ? q('#scdk-zip').value.trim() : '';
      var c = q('#scdk-city') ? q('#scdk-city').value.trim() : '';
      var s = q('#scdk-street') ? q('#scdk-street').value.trim() : '';
      var parts = [];
      if (s) parts.push(s);
      if (z || c) parts.push((z + ' ' + c).trim());
      return parts.join(', ').trim();
    }
    function ready() {
      return num(q('#scdk-a1')) > 0 &&
        ((q('#scdk-zip') && q('#scdk-zip').value.trim().length >= 4) ||
         (q('#scdk-city') && q('#scdk-city').value.trim().length >= 2));
    }
    function contactOk() {
      var n = q('#scdk-name'), e = q('#scdk-mail');
      return !!(n && n.value.trim().length >= 2) &&
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e ? e.value.trim() : '');
    }

    /* ------------------------------------------------------------- Ausgabe */
    var last = { net: null };

    function render() {
      var dist = num(q('#scdk-dist'));
      var hasWater = !!(q('#scdk-water') && q('#scdk-water').checked);

      var list = activeParts();
      var p1 = list[0] || part(1);

      var area = 0, cost = 0;
      list.forEach(function (p) { area += p.area || 0; cost += p.cost || 0; });

      var t = tier(area);
      var discount = 0;
      if (t && cost > 0) { discount = cost * t.rate; cost -= discount; }

      var water = hasWater ? 0 : CFG.waterSurcharge * area;
      var travel = CFG.kmRate * dist * 2;
      var raw = cost + water + travel;
      var minTopUp = Math.max(0, CFG.minJob - raw);
      var net = raw + minTopUp;
      var gross = net * (1 + CFG.vat);
      var perM2 = area > 0 ? net / area : 0;

      /* Preiskopf */
      setText('#scdk-net', euro(net), true);
      setText('#scdk-gross', 'inkl. ' + Math.round(CFG.vat * 100) + ' % MwSt.: ' + euro(gross));
      setText('#scdk-perm2', area > 0 ? euro(perM2) : '–');
      setText('#scdk-area', area > 0 ? area + ' m²' : '–');
      setText('#scdk-bar-net', euro(net));
      setText('#scdk-bar-area', area > 0 ? area + ' m²' : '–');

      /* Vergleichshinweis */
      var cmp = CFG.compare[p1.on ? p1.key : CFG.services[0].key];
      var savEl = q('#scdk-saving');
      if (savEl) {
        if (cmp && cmp.scaffold > 0 && cmp.sky > 0) {
          var pct = Math.round((1 - cmp.sky / cmp.scaffold) * 100);
          savEl.textContent = pct + ' % günstiger als Reinigung vom Gerüst';
          savEl.closest('.scdk-saving').hidden = false;
        } else {
          savEl.closest('.scdk-saving').hidden = true;
        }
      }

      /* Aufschlüsselung */
      var body = q('#scdk-rows');
      if (body) {
        body.innerHTML = '';
        group(body, 'Reinigungsleistung');
        list.forEach(function (p) {
          if (p.on) line(body, svc(p.key).name + ' · ' + p.area + ' m² · ' + soilLabel(p.soil) + ' · ' + p.height + ' m', euro(p.cost));
          else line(body, 'Fläche ' + p.index, 'noch keine Fläche', 'scdk-row--mute');
        });
        if (t && area > 0) {
          group(body, 'Rabatt');
          line(body, t.label, '− ' + euro(discount), 'scdk-row--plus');
        }
        group(body, 'Einsatzkosten');
        if (!hasWater && water > 0) line(body, 'Zuschlag ohne Wasseranschluss', euro(water));
        line(body, 'Anfahrt und Einsatzlogistik (' + (dist * 2) + ' km)', euro(travel));
        if (minTopUp > 0) {
          group(body, 'Mindestauftrag');
          line(body, 'Anhebung auf den Mindestauftrag von ' + euro(CFG.minJob), euro(minTopUp));
        }
        group(body, 'Zusammenfassung');
        line(body, 'Gesamt netto (Richtpreis)', euro(net), 'scdk-row--total');
        line(body, 'Mehrwertsteuer ' + Math.round(CFG.vat * 100) + ' %', euro(gross - net));
        line(body, 'Gesamt brutto', euro(gross), 'scdk-row--gross');
      }

      if (unlocked) drawCompare(p1.on ? p1.key : CFG.services[0].key);

      root.scdState = {
        parts: list, p1: p1, p2: list[1] || null,
        area: area, dist: dist, net: net, gross: gross, addr: address(), water: hasWater,
      };

      var revealBtn = q('#scdk-reveal');
      if (revealBtn) revealBtn.disabled = !(ready() && contactOk());
      steps();
      /* Ändert jemand links im Rechner etwas, zieht die Übersicht mit. */
      if (reviewing) fillReview(root.scdState);
    }

    function setText(sel, value, pop) {
      var el = q(sel);
      if (!el) return;
      if (pop && el.textContent === value) return;
      el.textContent = value;
      if (pop) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
    }
    function group(body, text) {
      var tr = document.createElement('tr');
      tr.className = 'scdk-row--group';
      tr.innerHTML = '<th colspan="2" scope="colgroup">' + text + '</th>';
      body.appendChild(tr);
    }
    function line(body, label, value, cls) {
      var tr = document.createElement('tr');
      if (cls) tr.className = cls;
      tr.innerHTML = '<td></td><td></td>';
      tr.children[0].textContent = label;
      tr.children[1].textContent = value;
      body.appendChild(tr);
    }

    /* ----------------------------------------------------------- Fortschritt */
    function steps() {
      var hasArea = num(q('#scdk-a1')) > 0;
      var hasAddr = (q('#scdk-zip') && q('#scdk-zip').value.trim().length >= 4) ||
                    (q('#scdk-city') && q('#scdk-city').value.trim().length >= 2);
      /* Nach dem Absenden steht der Dank in der Ergebnisspalte: alles erledigt. */
      var sent = !!q('#scdk-done');
      var state = sent ? ['done', 'done', 'done', 'done'] : [
        hasArea ? 'done' : 'now',
        hasArea && hasAddr ? 'done' : (hasArea ? 'now' : ''),
        unlocked ? 'done' : (hasArea && hasAddr ? 'now' : ''),
        unlocked ? 'now' : '',
      ];
      qa('.scdk-step').forEach(function (el, i) {
        el.classList.toggle('is-done', state[i] === 'done');
        el.classList.toggle('is-now', state[i] === 'now');
        el.setAttribute('aria-current', state[i] === 'now' ? 'step' : 'false');
      });
    }

    /* -------------------------------------------------------------- Vergleich */
    function drawCompare(key) {
      var wrap = q('#scdk-compare');
      if (!wrap) return;
      var c = CFG.compare[key];
      if (!c || !c.scaffold) { wrap.hidden = true; return; }
      wrap.hidden = false;
      var cost = [
        { n: 'Gerüst und Reinigung', v: c.scaffold },
        { n: 'Hubsteiger', v: c.lift },
        { n: 'SkyClean Drones', v: c.sky, own: true },
      ];
      var time = [
        { n: 'Gerüst aufbauen', v: c.hScaffold },
        { n: 'Reinigung herkömmlich', v: c.hConv },
        { n: 'SkyClean Drones', v: c.hSky, own: true },
      ];
      wrap.innerHTML = '';
      wrap.appendChild(bars('Kosten je m²', cost, function (v) { return v.toFixed(2).replace('.', ',') + ' €'; }));
      wrap.appendChild(bars('Zeitaufwand', time, function (v) { return v.toFixed(1).replace('.', ',') + ' Std.'; }));
    }
    function bars(title, rows, fmt) {
      var max = 0;
      rows.forEach(function (r) { if (r.v > max) max = r.v; });
      var card = document.createElement('div');
      card.className = 'scdk-cmp';
      var h = document.createElement('p');
      h.className = 'scdk-cmp__ttl';
      h.textContent = title;
      card.appendChild(h);
      rows.forEach(function (r) {
        var row = document.createElement('div');
        row.className = 'scdk-bar' + (r.own ? ' scdk-bar--own' : '');
        var name = document.createElement('span');
        name.className = 'scdk-bar__n';
        name.textContent = r.n;
        var track = document.createElement('span');
        track.className = 'scdk-bar__t';
        var fill = document.createElement('i');
        fill.style.width = '0%';
        track.appendChild(fill);
        var val = document.createElement('span');
        val.className = 'scdk-bar__v';
        val.textContent = fmt(r.v);
        row.appendChild(name); row.appendChild(track); row.appendChild(val);
        card.appendChild(row);
        var pct = max > 0 ? Math.round(r.v / max * 100) : 0;
        setTimeout(function () { fill.style.width = pct + '%'; }, 80);
      });
      return card;
    }

    /* ------------------------------------------------------------------ Karte
       Erst auf Klick. Vorher gibt es keine Verbindung zu OpenStreetMap,
       keine Kachel-Anfrage und keine IP-Adresse beim Kartendienst. */
    function loadMap() {
      var box = q('#scdk-map');
      if (!box || mapReady) return;
      mapReady = true;
      box.classList.add('is-loading');

      /* Prüfsummen (Subresource Integrity): Der Browser lädt die Dateien nur,
         wenn ihr Inhalt exakt passt. Würde jemand unpkg.com kapern und den
         Code austauschen, lehnt der Browser ihn ab, statt ihn auszuführen. */
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      css.integrity = 'sha384-sHL9NAb7lN7rfvG5lfHpm643Xkcjzp4jFvuavGOndn6pjVqS6ny56CAt3nsEVT4H';
      css.crossOrigin = 'anonymous';
      document.head.appendChild(css);

      var js = document.createElement('script');
      js.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      js.integrity = 'sha384-cxOPjt7s7Iz04uaHJceBmS+qpjv2JkIHNVcuOrM+YHwZOmJGBXI00mdUXEq65HTH';
      js.crossOrigin = 'anonymous';
      js.onload = function () {
        box.classList.remove('is-loading');
        box.classList.add('is-live');
        var target = box.querySelector('.scdk-map__canvas');
        map = L.map(target, { scrollWheelZoom: false }).setView([CFG.hq.lat, CFG.hq.lng], 9);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19, attribution: '&copy; OpenStreetMap',
        }).addTo(map);
        L.marker([CFG.hq.lat, CFG.hq.lng]).addTo(map).bindPopup(CFG.hqLabel || 'Standort');
        destMarker = L.marker([CFG.hq.lat, CFG.hq.lng]).addTo(map);
        locate();
      };
      js.onerror = function () {
        box.classList.remove('is-loading');
        box.textContent = 'Die Karte konnte nicht geladen werden.';
      };
      document.head.appendChild(js);
    }

    /* ------------------------------------------------------------- Entfernung */
    function get(url, cb) {
      var x = new XMLHttpRequest();
      x.open('GET', url, true);
      x.onreadystatechange = function () {
        if (x.readyState !== 4) return;
        try { if (x.status >= 200 && x.status < 300) { cb(JSON.parse(x.responseText)); return; } } catch (e) {}
        cb(null);
      };
      x.send();
    }
    function rad(d) { return d * Math.PI / 180; }
    function crow(a, b) {
      var R = 6371, dLat = rad(b.lat - a.lat), dLng = rad(b.lng - a.lng);
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
    }
    function applyDistance(point) {
      if (map && destMarker) {
        destMarker.setLatLng([point.lat, point.lng]);
        map.fitBounds(L.latLngBounds([[CFG.hq.lat, CFG.hq.lng], [point.lat, point.lng]]), { padding: [26, 26] });
      }
      get('https://router.project-osrm.org/route/v1/driving/' + CFG.hq.lng + ',' + CFG.hq.lat +
          ';' + point.lng + ',' + point.lat + '?overview=false', function (r) {
        var km = (r && r.code === 'Ok' && r.routes && r.routes[0]) ? r.routes[0].distance / 1000 : null;
        var value = (km && isFinite(km)) ? km : crow(CFG.hq, point) * CFG.detour;
        var el = q('#scdk-dist');
        if (el) el.value = Math.round(value);
        status('Entfernung übernommen: ' + Math.round(value) + ' km einfach.');
        render();
      });
    }
    function locate() {
      var addr = address();
      if (addr.length < 4) { status('Bitte zuerst PLZ oder Stadt eintragen.'); return; }
      status('Entfernung wird ermittelt …');
      get('https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(addr), function (a) {
        if (a && a[0]) applyDistance({ lat: parseFloat(a[0].lat), lng: parseFloat(a[0].lon) });
        else status('Adresse nicht gefunden – bitte Entfernung von Hand eintragen.');
      });
    }
    function useGeolocation() {
      if (!navigator.geolocation) { status('Standortbestimmung wird vom Browser nicht angeboten.'); return; }
      status('Standort wird abgefragt …');
      navigator.geolocation.getCurrentPosition(function (pos) {
        var here = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        applyDistance(here);
        get('https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1&lat=' + here.lat + '&lon=' + here.lng, function (info) {
          if (!info || !info.address) return;
          var a = info.address;
          if (q('#scdk-zip')) q('#scdk-zip').value = a.postcode || '';
          if (q('#scdk-city')) q('#scdk-city').value = a.city || a.town || a.village || '';
          if (q('#scdk-street')) q('#scdk-street').value = ((a.road || '') + (a.house_number ? ' ' + a.house_number : '')).trim();
          render();
        });
      }, function (err) {
        status(err.code === 1 ? 'Freigabe wurde verweigert.' : 'Standort ist nicht verfügbar.');
      }, { enableHighAccuracy: true, timeout: 10000 });
    }
    function status(text) {
      var el = q('#scdk-status');
      if (el) el.textContent = text;
    }

    /* ----------------------------------------------------- Schieber und Zahl */
    function couple(rangeSel, numberSel) {
      var r = q(rangeSel), n = q(numberSel);
      if (!r || !n) return;
      r.addEventListener('input', function () { n.value = r.value; render(); });
      n.addEventListener('input', function () {
        var v = Math.min(Number(r.max), Math.max(Number(r.min), num(n)));
        r.value = v;
        render();
      });
      r.value = num(n);
    }

    /* ------------------------------------------------------------------ Start */
    qa('input, select').forEach(function (el) {
      el.addEventListener('input', render);
      el.addEventListener('change', render);
    });
    for (var i = 1; i <= (CFG.maxParts || 2); i++) {
      couple('#scdk-a' + i + 'r', '#scdk-a' + i);
      couple('#scdk-h' + i + 'r', '#scdk-h' + i);
    }

    /* Flächen ein- und ausblenden. Die erste bleibt immer stehen. */
    var addBtn = q('#scdk-add');
    var addLabel = addBtn ? addBtn.querySelector('[data-scdk-add-label]') : null;
    var addHint = q('[data-scdk-add-hint]');

    function nextHidden() {
      for (var i = 2; i <= (CFG.maxParts || 2); i++) {
        var box = q('#scdk-pos' + i);
        if (box && box.hidden) return box;
      }
      return null;
    }

    function syncAdd() {
      if (!addBtn) return;
      var free = nextHidden();
      addBtn.hidden = !free;
      if (addHint) addHint.hidden = !free;
      if (addLabel) {
        addLabel.textContent = activeParts().length > 1
          ? 'Noch eine Fläche hinzufügen'
          : 'Weitere Fläche hinzufügen';
      }
    }

    if (addBtn) addBtn.addEventListener('click', function () {
      var box = nextHidden();
      if (!box) return;
      box.hidden = false;
      var first = box.querySelector('input[type="number"]');
      if (first) first.focus();
      syncAdd();
      render();
    });

    root.querySelectorAll('[data-scdk-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = btn.getAttribute('data-scdk-remove');
        var box = q('#scdk-pos' + n);
        if (!box) return;
        /* Werte zurücksetzen, damit eine später wieder eingeblendete Fläche
           nicht mit alten Zahlen zurückkommt. */
        var a = q('#scdk-a' + n), ar = q('#scdk-a' + n + 'r');
        var h = q('#scdk-h' + n), hr = q('#scdk-h' + n + 'r');
        if (a) a.value = 0;
        if (ar) ar.value = 0;
        if (h) h.value = 0;
        if (hr) hr.value = 0;
        box.hidden = true;
        syncAdd();
        if (addBtn && !addBtn.hidden) addBtn.focus();
        render();
      });
    });

    syncAdd();

    var mapBtn = q('#scdk-map-load');
    if (mapBtn) mapBtn.addEventListener('click', loadMap);
    var distBtn = q('#scdk-locate');
    if (distBtn) distBtn.addEventListener('click', locate);
    var geoBtn = q('#scdk-geo');
    if (geoBtn) geoBtn.addEventListener('click', useGeolocation);

    var gate = q('#scdk-gate'), result = q('#scdk-result');

    function unlock() {
      if (!ready()) { status('Bitte Fläche sowie PLZ oder Stadt eintragen.'); return; }
      if (!contactOk()) { status('Bitte Namen und eine gültige E-Mail-Adresse eintragen.'); return; }
      unlocked = true;
      if (gate) gate.hidden = true;
      if (result) {
        result.hidden = false;
        requestAnimationFrame(function () { result.classList.add('is-shown'); });
      }
      var to = q('[data-scdk-to]');
      if (to) to.textContent = q('#scdk-mail').value.trim();
      root.classList.add('is-unlocked');
      render();
      setTimeout(function () {
        if (result) result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
    }

    var reveal = q('#scdk-reveal');
    if (reveal) reveal.addEventListener('click', unlock);

    /* „ändern“ neben der Antwortadresse: zurück zu Name und E-Mail. */
    root.querySelectorAll('[data-scdk-edit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        unlocked = false;
        closeReview();
        if (result) { result.classList.remove('is-shown'); result.hidden = true; }
        if (gate) gate.hidden = false;
        root.classList.remove('is-unlocked');
        render();
        var mail = q('#scdk-mail');
        if (mail) mail.focus();
      });
    });

    /* Die Angaben in der Form, die /pages/contact als Parameter erwartet.
       Nur noch der Ausweg, falls Shopify die direkte Anfrage ablehnt. */
    function contactParams(st) {
      var name = q('#scdk-name') ? q('#scdk-name').value.trim() : '';
      var mail = q('#scdk-mail') ? q('#scdk-mail').value.trim() : '';
      var p = new URLSearchParams();
      p.set('scd_name', name);
      p.set('scd_email', mail);
      p.set('scd_zip', q('#scdk-zip') ? q('#scdk-zip').value.trim() : '');
      p.set('scd_city', q('#scdk-city') ? q('#scdk-city').value.trim() : '');
      /* Das Kontaktformular hat ein eigenes Feld für die Straße und zeigt
         sie in der Übersicht – sie muss also mitgegeben werden. */
      p.set('scd_street', q('#scdk-street') ? q('#scdk-street').value.trim() : '');
      p.set('scd_addr', st.addr || '');
      p.set('scd_distance', st.dist || 0);
      p.set('scd_net', (st.net || 0).toFixed(2));
      p.set('scd_gross', (st.gross || 0).toFixed(2));
      p.set('scd_total_area', st.area || 0);
      p.set('scd_service', svc(st.p1.key).name);
      p.set('scd_area', st.p1.area);
      p.set('scd_height', st.p1.height);
      p.set('scd_soil', soilLabel(st.p1.soil));
      /* Alle Flächen zusätzlich als eine Liste. Das Kontaktformular hat
         feste Felder nur für zwei – über diese Zeile kommen auch die
         dritte, vierte und fünfte mit, ohne dass dort für jede ein eigenes
         Feld nötig wäre. Aufbau je Zeile: Leistung | m² | Höhe | Grad */
      var posLines = (st.parts || []).filter(function (x) { return x.on; }).map(function (x) {
        return [svc(x.key).name, x.area, x.height, soilLabel(x.soil)].join(' | ');
      });
      if (posLines.length) p.set('scd_positions', posLines.join('\n'));
      if (st.p2 && st.p2.on) {
        p.set('scd_service_2', svc(st.p2.key).name);
        p.set('scd_area_2', st.p2.area);
        p.set('scd_height_2', st.p2.height);
        p.set('scd_soil_2', soilLabel(st.p2.soil));
      }
      return p;
    }

    /* ------------------------------------------------- Anfrage direkt senden
       Die Ergebnisspalte ist ein Shopify-Kontaktformular. Beim Absenden
       kommt die Kalkulation in die Nachricht und in eigene Felder der
       Anfrage-Mail (gleiche Namen wie auf /pages/contact). Das eigentliche
       Senden – samt hCaptcha – macht Shopify. */
    var KEY = 'scdk-anfrage';
    var sendForm = q('#scdk-anfrage');
    var sendBtn = q('#scdk-forward');

    function sendStatus(text) {
      var el = q('#scdk-send-status');
      if (el) el.textContent = text;
    }

    function val(sel) { return q(sel) ? q(sel).value.trim() : ''; }

    /* --------------------------------------------- Übersicht vor dem Senden
       Der Kunde sieht alles, was wir bekommen, und schickt erst dann ab. */
    function fillReview(st) {
      var list = q('#scdk-review-list');
      if (!list || !st) return;
      var rows = [['Name', val('#scdk-name')], ['E-Mail', val('#scdk-mail')], ['Telefon', val('#scdk-phone')], ['Objekt', st.addr]];
      st.parts.filter(function (p) { return p.on; }).forEach(function (p, i, all) {
        rows.push([all.length > 1 ? 'Fläche ' + (i + 1) : 'Fläche',
          [svc(p.key).name, p.area + ' m²', p.height + ' m Höhe', soilLabel(p.soil) + ' verschmutzt'].join(' · ')]);
      });
      if (st.dist > 0) rows.push(['Entfernung', st.dist + ' km einfach']);
      rows.push(['Wasser vor Ort', st.water ? 'Ja' : 'Nein']);
      rows.push(['Richtpreis', euro(st.net) + ' netto · ' + euro(st.gross) + ' brutto']);
      rows.push(['Nachricht', val('#scdk-msg')]);
      list.innerHTML = '';
      rows.forEach(function (row) {
        if (!row[1]) return;
        var d = document.createElement('div');
        d.innerHTML = '<dt></dt><dd></dd>';
        d.children[0].textContent = row[0];
        d.children[1].textContent = row[1];
        list.appendChild(d);
      });
    }

    function openReview() {
      var st = root.scdState;
      if (!st || !st.p1 || !st.p1.on) { sendStatus('Bitte zuerst eine Fläche eintragen.'); return; }
      if (!contactOk()) { sendStatus('Bitte Namen und E-Mail prüfen.'); return; }
      sendStatus('');
      reviewing = true;
      fillReview(st);
      var edit = q('#scdk-send-edit'), review = q('#scdk-review');
      if (edit) edit.hidden = true;
      if (review) review.hidden = false;
      var ttl = q('#scdk-review-ttl');
      if (ttl) {
        ttl.focus({ preventScroll: true });
        ttl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function closeReview() {
      reviewing = false;
      var edit = q('#scdk-send-edit'), review = q('#scdk-review');
      if (review) review.hidden = true;
      if (edit) edit.hidden = false;
    }

    var checkBtn = q('#scdk-check');
    if (checkBtn) checkBtn.addEventListener('click', openReview);
    root.querySelectorAll('[data-scdk-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeReview();
        var phone = q('#scdk-phone');
        if (phone) phone.focus();
      });
    });

    function bodyText(st) {
      var lines = ['--- SkyClean Kalkulation ---'];
      st.parts.filter(function (p) { return p.on; }).forEach(function (p, i) {
        lines.push('Fläche ' + (i + 1) + ': ' + [svc(p.key).name, p.area + ' m²', p.height + ' m', soilLabel(p.soil)].join(' · '));
      });
      lines.push('Gesamtfläche: ' + st.area + ' m²');
      if (st.addr) lines.push('Objektstandort: ' + st.addr);
      lines.push('Entfernung: ' + st.dist + ' km einfach');
      lines.push('Wasser vor Ort: ' + (st.water ? 'Ja' : 'Nein'));
      lines.push('Richtpreis netto: ' + euro(st.net));
      lines.push('Richtpreis brutto: ' + euro(st.gross));
      lines.push('--- Ende ---');
      var note = val('#scdk-msg');
      if (note) lines.push('', 'Nachricht:', note);
      return lines.join('\n');
    }

    function fillSend(st) {
      var box = q('#scdk-send-fields');
      if (box) {
        box.innerHTML = '';
        var put = function (name, value) {
          if (value === '' || value == null) return;
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'contact[' + name + ']';
          input.value = String(value);
          box.appendChild(input);
        };
        put('Quelle', 'Kostenrechner');
        st.parts.filter(function (p) { return p.on; }).forEach(function (p, i) {
          var n = 'Bereich' + (i + 1) + '_';
          put(n + 'Leistungsart', svc(p.key).name);
          put(n + 'Fläche_m2', p.area);
          put(n + 'Höhe_m', p.height);
          put(n + 'Verschmutzung', soilLabel(p.soil));
        });
        put('Gesamtfläche_m2', st.area);
        put('Entfernung_km', st.dist);
        put('Wasseranschluss', st.water ? 'Ja' : 'Nein');
        put('Preis_netto', st.net.toFixed(2));
        put('Preis_brutto', st.gross.toFixed(2));
        put('Adresse_Ort', st.addr);
        put('PLZ', val('#scdk-zip'));
        put('Stadt', val('#scdk-city'));
        put('Straße', val('#scdk-street'));
      }
      var body = q('#scdk-body');
      if (body) body.value = bodyText(st);
    }

    /* Für den Dank nach dem Neuladen und für den Ausweg über /pages/contact.
       Ohne sessionStorage fehlt nur die kleine Übersicht. */
    function remember(st) {
      try {
        sessionStorage.setItem(KEY, JSON.stringify({
          sum: [
            ['Richtpreis netto', euro(st.net)],
            ['Fläche gesamt', st.area + ' m²'],
            ['Objekt', st.addr],
            ['Antwort an', val('#scdk-mail')],
          ],
          params: contactParams(st).toString(),
        }));
      } catch (e) {}
    }
    function recall() {
      try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
    }

    function resetSendBtn() {
      if (!sendBtn) return;
      sendBtn.classList.remove('is-sending');
      sendBtn.removeAttribute('aria-busy');
      var label = sendBtn.querySelector('[data-scdk-send-label]');
      if (label && label.dataset.text) label.textContent = label.dataset.text;
    }

    /* Shopify hängt an das Formular einen eigenen hCaptcha-Listener, der nach
       dem Captcha selbst absendet – auch wenn wir preventDefault() rufen.
       Darum prüfen wir im Capture-Schritt am Abschnitt, also bevor das
       Ereignis das Formular erreicht. Brechen wir hier ab, kommt es nie dort an. */
    if (sendForm) root.addEventListener('submit', function (e) {
      if (e.target !== sendForm) return;
      var st = root.scdState;
      var stop = function (text) {
        e.preventDefault();
        e.stopPropagation();
        if (text) sendStatus(text);
      };
      /* Enter im Namens- oder E-Mail-Feld zeigt erst den Preis, Enter im
         Telefonfeld erst die Übersicht. Abgeschickt wird nur aus ihr. */
      if (!unlocked) { stop(); unlock(); return; }
      if (!reviewing) { stop(); openReview(); return; }
      if (!st || !st.p1 || !st.p1.on) return stop('Bitte zuerst eine Fläche eintragen.');
      if (!contactOk()) return stop('Bitte Namen und E-Mail prüfen.');
      sendStatus('');
      fillSend(st);
      remember(st);
      if (sendBtn) {
        sendBtn.classList.add('is-sending');
        sendBtn.setAttribute('aria-busy', 'true');
        var label = sendBtn.querySelector('[data-scdk-send-label]');
        if (label) {
          label.dataset.text = label.dataset.text || label.textContent;
          label.textContent = 'Wird gesendet …';
        }
        /* Schließt jemand das Captcha-Fenster, lädt die Seite nicht neu –
           dann darf der Knopf nicht im Sendezustand hängen bleiben. */
        setTimeout(resetSendBtn, 8000);
      }
    }, true);

    /* Nach dem Neuladen: Dank mit kurzer Übersicht, oder bei einem Fehler
       der Link zur Kontaktseite mit der Kalkulation. */
    var done = q('#scdk-done');
    var saved = recall();
    if (done) {
      var sum = q('#scdk-done-sum');
      if (sum && saved && saved.sum) {
        saved.sum.forEach(function (row) {
          if (!row[1]) return;
          var d = document.createElement('div');
          d.innerHTML = '<dt></dt><dd></dd>';
          d.children[0].textContent = row[0];
          d.children[1].textContent = row[1];
          sum.appendChild(d);
        });
        sum.hidden = !sum.children.length;
      }
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      done.focus({ preventScroll: true });
    }
    var fallback = q('[data-scdk-fallback]');
    if (fallback && saved && saved.params) {
      fallback.href = (CFG.contactUrl || '/pages/contact') + '?' + saved.params;
    }

    /* Preisleiste am unteren Rand, sobald der Rechner im Bild ist (nur Handy) */
    if ('IntersectionObserver' in window) {
      var bar = q('.scdk-bar-mobile');
      var form = q('.scdk-form');
      if (bar && form) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { bar.classList.toggle('is-on', e.isIntersecting); });
        }, { threshold: 0.02 }).observe(form);
      }
    }

    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-scd-calculator]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
